import { TrackingEventConstants } from '../../../../../constants/tracking'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from '../../../../shared/Button'
import { selectModalAffordability } from '../../../../../store/selectors/affordability'
import { useSelector } from 'react-redux'
import { useTrackingContext } from '../../../../../providers/tracking'
import styles from './PersistAffordabilityButton.module.scss'
import { formatAbbrCurrency } from 'src/helpers/formatters'

const propTypes = {
  className: PropTypes.string
}

const PersistAffordabilityButton = ({ className, ...restProps }) => {
  const { trackingClient } = useTrackingContext()
  const value = useSelector(selectModalAffordability)

  const handleClick = () => {
    trackingClient?.clientCustomized({
      customization_type: TrackingEventConstants.CLIENT_UPDATED_PRICE_POINT
    })
  }

  return (
    <Button
      data-qa='affordabilitySubmitButton'
      className={classnames(styles.root, className)}
      type='submit'
      onClick={handleClick}
      {...restProps}
    >
      <FormattedMessage
        id='Affordability.modal.submitButton'
        defaultMessage='Explore with {value}'
        values={{
          value: formatAbbrCurrency(value)
        }}
      />
    </Button>
  )
}

PersistAffordabilityButton.propTypes = propTypes

export default PersistAffordabilityButton
